import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all categorys
export const getCategory = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/categories`);
    return response.data;
  } catch (error) {
    console.error("Error fetching categories:", error.response?.data || error);
    throw error;
  }
};

// GET a single category
export const getCategoryById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/categories/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching category:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new category
export const createCategory = async (categoryData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/categories`, categoryData);
    return response.data;
  } catch (error) {
    console.error("Error creating category:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing category
export const updateCategory = async (id, categoryData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/categories/${id}`, categoryData);
    return response.data;
  } catch (error) {
    console.error("Error updating category:", error.response?.data || error);
    throw error;
  }
};

// DELETE a category
export const deleteCategory = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/categories/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting category:", error.response?.data || error);
    throw error;
  }
};
